export default __webpack_public_path__ + "static/media/ContactMain.06dbce04.jpg";